import { TreeProjectChoice, TREE_PROJECT_PROBABILITY_MIN, TREE_PROJECT_PROBABILITY_RANGE_MAX } from '../tree-projects';
import { clamp } from './clamp';

export type Choices = Array<[projectId: number, percent: number]>;

export const calculateTreeProjectProbability = (choices: Choices): TreeProjectChoice[] => {
  return choices.reduce<{ choices: TreeProjectChoice[]; lowerBound: number }>(
    (acc, [projectId, percent]) => {
      const upperBound = clamp(
        TREE_PROJECT_PROBABILITY_MIN,
        Math.round((percent / 100) * TREE_PROJECT_PROBABILITY_RANGE_MAX + acc.lowerBound),
        TREE_PROJECT_PROBABILITY_RANGE_MAX,
      );

      acc.choices.push({
        projectId,
        probabilityLowerBound: acc.lowerBound,
        probabilityUpperBound: upperBound,
      });

      acc.lowerBound = upperBound;

      return acc;
    },
    {
      choices: [],
      // Progressively increment the lower bound per each iteration
      lowerBound: TREE_PROJECT_PROBABILITY_MIN,
    },
  ).choices;
};
